/**
 * @file gisSettings.js - options à inclure et options spécifiques au projet
 * @author : Adam Lemire
 * @since 2019/11/05
 * @version 1.0
 * @summary Dernières modifications : 2022/04/01
 */

export const gisSettings = {
  versionSig: 'iBalsac 1.0',
  mapTitleBar: {
    active: true
  },
  topMenu: {
    active: true,
    projectMenu: {
      active: true
    },
    saveProjectButton: {
      active: false
    },
    saveProjectAPIButton: {
      active: true
    },
    addMapButton: {
      active: true
    },
    importDataButton: {
      active: false
    },
    importDataAPIButton: {
      active: true
    },
    mapControls: {
      active: true
    },
    helpButton: {
      active: true
    },
    exportPdfButton: {
      active: false
    }
  },
  leftMenu: {
    active: true,
    mapLayers: {
      active: true
    },
    webLayers: {
      active: true
    },
    multimapLayers: {
      active: true
    },
    printLayout: {
      active: true
    }
  },
  mapTabsBar: {
    active: true
  },
  options: {
    map: {
      addNewMap: {
        active: true
      },
      export: {
        active: true
      },
      delete: {
        active: true
      },
      editName: {
        active: true
      }
    },
    data: {
      import: {
        active: false
      },
      importerDepuisEspaceChercheur: {
        active: true
      }
    },
    project: {
      editName: {
        active: true
      },
      importerDepuisEspaceChercheur: {
        active: true
      },
      chargementLocal: {
        active: true
      },
      chargementDepuisEspaceChercheur: {
        active: true
      },
      autoSave: {
        active: true
      },
      sauvegardeLocale: {
        active: false
      },
      sauvegardeAPI: {
        active: true
      }
    },
    layer: {
      edit: {
        active: true
      },
      editProperties: {
        active: true
      },
      remove: {
        active: true
      },
      attributeTable: {
        active: true
      },
      infoOnMap: {
        active: true
      },
      coucheLabel: {
        active: true
      }
    }
  },
  url: {
    api: {
      listeProjetsEspaceChercheur: 'https://ibalsac.api.cieq.ca/projets/',
      ouvertureProjetEspaceChercheur: 'https://ibalsac.api.cieq.ca/projet/',
      listeFichiersDonneesEspaceChercheur: 'https://ibalsac.api.cieq.ca/selections/',
      importerFichierDonneesEspaceChercheur: 'https://ibalsac.api.cieq.ca/selection/'
    }
  },
  geoserver: {
    url: {
      serveurCieq: 'https://cieqinternet.uqtr.ca/geoserver',
      serveurCieqCarto: 'https://cieqcarto.uqtr.ca/geoserver'
    },
    workspace: {
      cieq: {
        nom: 'ibalsac',
        urlCapabilities: 'https://cieqinternet.uqtr.ca/geoserver/ibalsac/gwc/service/wmts?REQUEST=GetCapabilities'
      },
      cieqcarto: {
        nom: 'ibalsac_dev2',
        urlCapabilities: 'https://cieqcarto.uqtr.ca/geoserver/ibalsac_dev2/gwc/service/wmts?REQUEST=GetCapabilities'
      }
    }
  }
};
// 'http://localhost:3003/     'https://ibalsac.api.cieq.ca/projets/3',

/**
 * @description Informations pour couches raster du web et cieq
 * @enum {string}
 */
export const WebRasterLayer = {
  OSM: {
    name: 'Open Street Map',
    sourceType: 'OSM'
  },
  NationalMapTopo: {
    name: 'National Map - Topo',
    sourceType: 'NationalMap',
    url: 'https://basemap.nationalmap.gov/arcgis/services/USGSTopo/MapServer/WMSServer'
  },
  NationalMapImageryTopo: {
    name: 'National Map - ImageryTopo',
    sourceType: 'NationalMap',
    url: 'https://basemap.nationalmap.gov/arcgis/services/USGSImageryTopo/MapServer/WMSServer'
  },
  NationalMapHydro: {
    name: 'National Map - Hydro',
    sourceType: 'NationalMap',
    url: 'https://basemap.nationalmap.gov/arcgis/services/USGSHydroCached/MapServer/WMSServer'
  },
  NationalMapImagery: {
    name: 'National Map - Imagery',
    sourceType: 'NationalMap',
    url: 'https://basemap.nationalmap.gov/arcgis/services/USGSImageryOnly/MapServer/WMSServer'
  },
  NationalMapRelief: {
    name: 'National Map - Shaded Relief',
    sourceType: 'NationalMap',
    url: 'https://basemap.nationalmap.gov/arcgis/services/USGSShadedReliefOnly/MapServer/WMSServer'
  }
};
